import React, { useState } from 'react';
import { Card, DatePicker, Button, AutoComplete, Space, message, Radio } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
import './StockComponents.css';

const { RangePicker } = DatePicker;

const StockSearch = ({ setStockData, setStockInfo, setLoading, loading }) => {
  const [keyword, setKeyword] = useState('');
  const [tsCode, setTsCode] = useState('');
  const [dateRange, setDateRange] = useState([dayjs().subtract(1, 'year'), dayjs()]);
  const [adj, setAdj] = useState('qfq');
  const [searchOptions, setSearchOptions] = useState([]);

  const handleSearch = async (value) => {
    setKeyword(value);
    if (!value) {
      setSearchOptions([]);
      return;
    }
    try {
      const response = await axios.get('/api/stock/search', { params: { keyword: value } });
      if (response.data.data) {
        setSearchOptions(
          response.data.data.map(item => ({
            value: item.ts_code,
            label: `${item.ts_code} - ${item.name}`
          }))
        );
      }
    } catch (error) {
      console.error('搜索失败:', error);
    }
  };

  const handleSelect = (value) => {
    setTsCode(value);
    setKeyword(value);
  };

  const handleQuery = async () => {
    const codeToUse = tsCode || keyword;
    if (!codeToUse) {
      message.warning('请输入或选择股票代码');
      return;
    }

    setLoading(true);
    try {
      const [startDate, endDate] = dateRange;
      const response = await axios.get('/api/stock/data', {
        params: {
          ts_code: codeToUse,
          start_date: startDate.format('YYYYMMDD'),
          end_date: endDate.format('YYYYMMDD'),
          period: 'daily', // 总是获取日K数据，在前端生成其他周期
          adj: adj
        }
      });

      if (response.data.data && response.data.data.length > 0) {
        // 确保数据按日期排序
        const sortedData = response.data.data.sort((a, b) => 
          new Date(a.trade_date) - new Date(b.trade_date)
        );
        
        const infoResponse = await axios.get('/api/stock/info', {
          params: { ts_code: codeToUse }
        });
        // 调用 handleStockDataChange 函数，传递两个参数：数据和信息
        setStockData(sortedData, infoResponse.data.data);
        message.success('查询成功');
      } else {
        message.warning('未查询到数据');
        setStockData(null, null);
      }
    } catch (error) {
      message.error('查询失败: ' + (error.response?.data?.error || error.message));
      setStockData(null, null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="search-card" variant="outlined">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Space size="middle" wrap>
          <AutoComplete
            style={{ width: 200 }}
            options={searchOptions}
            onSearch={handleSearch}
            onSelect={handleSelect}
            placeholder="输入股票代码或名称搜索"
            allowClear
          />
          <RangePicker
            value={dateRange}
            onChange={setDateRange}
            format="YYYY-MM-DD"
          />
          <Radio.Group value={adj} onChange={(e) => setAdj(e.target.value)} buttonStyle="solid">
            <Radio.Button value="qfq">前复权</Radio.Button>
            {/* <Radio.Button value="hfq">后复权</Radio.Button> */}
            <Radio.Button value="">不复权</Radio.Button>
          </Radio.Group>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleQuery}
            loading={loading}
          >
            查询
          </Button>
        </Space>
      </Space>
    </Card>
  );
};

export default StockSearch;
